import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { catchError, map, Observable, shareReplay, take } from 'rxjs';
import { BookingListModel } from '../../../../models/booking.model';
import { BookingService } from '../../../../services/booking.service';
import { UserService } from '../../../../services/user.service';
import { getStatus, getStatusString } from '../../../../utils/booking.utils';
import {
  Filter,
  TableColumn,
} from '../../../shared-components/custom-table/custom-table.component';

@Component({
  selector: 'app-user-bookings',
  templateUrl: './bookings.component.html',
  styleUrl: './bookings.component.scss',
  standalone: false,
})
export class UserBookingsComponent {
  public isLoading = true;
  public dataSource$: Observable<BookingListModel[]>;

  constructor(
    private bookingService: BookingService,
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.getBookings();
  }

  private getBookings() {
    const id = this.userService.currentUser$.value.id;
    this.dataSource$ = this.bookingService.getBookingsByUser(id).pipe(
      take(1),
      map(bookings => {
        this.isLoading = false;
        return bookings;
      }),
      catchError(error => {
        this.isLoading = false;
        console.error('Error fetching bookings', error);
        return [];
      }),
      shareReplay(1) // Cache the result
    );
  }

  public columns: TableColumn[] = [
    {
      columnDef: 'seminarName',
      header: 'Seminar',
      width: '25%',
      sortable: true,
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'seminarNr',
      header: 'Seminar ID',
      width: '15%',
      fontWeight: '400',
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'createdAt',
      header: 'gebucht am',
      width: '15%',
      fontWeight: '400',
      filterValue: row => moment(row.createdAt).format('DD.MM.YYYY'),
      render: row => moment(row.createdAt).format('DD.MM.YYYY'),
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'bookingNr',
      header: 'Buchungs ID',
      width: '15%',
      fontWeight: '400',
      onCellClick: this.onCellClick.bind(this),
    },
    {
      columnDef: 'status',
      header: 'Status',
      width: '10%',
      fontWeight: '400',
      filterValue: row => getStatusString(row),
      render: row => {
        const { status, class: statusClass } = getStatus(row);

        return `<div class="${statusClass}">
        ${status}
      </div>`;
      },
    },
  ];

  // Define the function that will be passed to the table component
  public onCellClick(row: BookingListModel, column: any) {
    this.router.navigate(['bookings', btoa(String(row.id))], {
      relativeTo: this.activatedRoute,
    });
  }

  public filters: Filter[] = [
    {
      filteredColumn: 'createdAt',
      type: 'date',
      label: 'Buchungsdatum',
    },
    {
      filteredColumn: 'status',
      type: 'multiselect',
      selectOptions: [
        {
          value: 'confirmed',
          label: 'Bezahlt',
        },
        {
          value: 'late',
          label: 'Verspätet',
        },
        {
          value: 'waitlist',
          label: 'Warteliste',
        },
        {
          value: 'pending',
          label: 'Ausstehend',
        },
        {
          value: 'cancelled',
          label: 'Storniert',
        },
      ],
      placeholder: 'Status auswählen...',
      label: 'Status',
    },
  ];
}
